import React, { Component } from 'react';
import _AdminService from 'modules/AdminService';
import _StudentService from 'modules/StudentService';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { PROJECT_LOGO, INTERVIEW_CALL_DATES } from '../../constants/constants';
import _branding from 'modules/branding';
import _utils from 'modules/Utils';

// Branding/UI Artifact Forensic Audit — Final Re-Investigation phase: this screen's Back/Print
// buttons previously used `ButtonComponent` (components/controls/Button, `btn-secondary`/
// `btn-tertiary` classes) — visually reported as looking like older, legacy UI compared to the
// rest of the modernized candidate journey (ResultCard_new.jsx). Switched to the same `antd`
// Button + `button-global` class pattern ResultCard_new.jsx already uses for its own Interview
// Schedule/Call Letter/Appointment Letter action buttons, so every button a candidate sees across
// the Result → Interview → Appointment sequence now shares one consistent design language.
import { Spin, Button } from 'antd';

class StudentAppointmentLetter extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            loading: true,
            // Note: "",
            AppointmentLetterNote: "",
            // Branding/UI Artifact Forensic Audit phase: kept only for the download filename
            // (buildAppointmentLetterFileName) — see processAppointmentData/onPrint below.
            fileNameModel: null,
            // Quick fix: real release date (server-sourced) and roll number for the Ref line — see
            // processAppointmentData/render below.
            publishedDate: "",
            rollNumberForRef: "",
        };
    }

    componentDidMount() {
        //this.getStudentPersonalData()
        this.processAppointmentData()

    }

    getDateForValue(inputValue) {
        if (inputValue === undefined || inputValue === null) {
            console.log('inputValue is undefined or null');
        }

        let inputValueStr = inputValue != null ? inputValue.toString() : '';

        let inputValueNum = Number(inputValueStr);
        console.log('inputValueNum:', inputValueNum);

        let result = this.state.interviewCallDates.find((item) =>
            item.value.includes(inputValueNum)
        );

        return result ? result : "Not Found";
    }

    // getStudentInterviewDetails = async () => {
    //     try {
    //         this.setState({ loading: true }, async () => {
    //             try {

    //                 let response = await _StudentService.getStudentInterviewTimeDateByApplicationID();

    //                 console.log(response.data.Obj);
    //                 if (response && response.data.Obj) {
    //                     this.processAppointmentData(response.data.Obj);

    //                 } else {
    //                     this.setState({ loading: false });
    //                     console.log('Error: No data found for the given Application ID');
    //                 }

    //             } catch (e) {
    //                 // TODO
    //                 this.setState({ loading: false });
    //                 console.log('Error: ', e);
    //             }
    //         });
    //     } catch (e) { }
    // }

    processAppointmentData = async () => {
        try {
            try {

                const response = await _AdminService.getStudentAppointmentDataByRoleNumber();
                debugger
                let studentData = response.data.Obj;

                console.log("studentData", studentData);

                let AppointmentLetter = studentData.AppointmentLetterNote;
                let Roll_Number = studentData.RoleNumber
                let Application_Id = studentData.ApplicationId || null;
                let AppointmentDate = studentData.Date;  // from API response


                let AppointmentTime = studentData.Time;  // from API response
                let Venue = studentData.Venue;        // from API response
                let Applied_Post = studentData.Post;
                let name = studentData.FirstName + " " + (studentData.MiddleName ? studentData.MiddleName + " " : "") + (studentData.LastName ? studentData.LastName : '');
                let Other1 = studentData.Other1;

                //Address, Village, Taluka, District, State, Pin Code

                // let updateNameInAppointmentLetter = AppointmentLetter.replaceAll("उमेदवारांचे नाव", name);
                // let updateApplicationIdInAppointmentLetter = updateNameInAppointmentLetter.replaceAll("अर्जक्र", Application_Id);
                // let updateRollNumberInAppointmentLetter = updateApplicationIdInAppointmentLetter.replaceAll("बैठकक्र", Roll_Number);
                // let updateVenueInAppointmentLetter = updateRollNumberInAppointmentLetter.replaceAll("ठिकाण",Venue);
                // let updateDateInAppointmentLetter = updateVenueInAppointmentLetter.replaceAll("तारीख",AppointmentDate);
                // let updateTimeStudentAppointmentLetter = updateDateInAppointmentLetter.replaceAll("वेळ",AppointmentTime);
                // let mainAppointmentLetter = updateTimeStudentAppointmentLetter.replaceAll("पदनाव", Applied_Post);

                // Production Candidate Journey Correction phase — real defect fix (§8: "Diagnose the
                // incorrect Appointment Letter... fields appear incorrectly mapped"). The commented-out
                // block just above is the ORIGINAL, correct intended mapping — "ठिकाण" (Reporting
                // Address/Location) was meant to merge with the actual reporting Venue, exactly as
                // written there. At some point the live code below was changed to merge "ठिकाण" with
                // the CANDIDATE'S OWN HOME ADDRESS instead (nonsensical: the letter's own preceding
                // sentence says "report... at the address below," not "here is your address on file"),
                // and "ता:" — the template's Taluka-abbreviation token, sitting next to the English
                // label "Reporting Date:" — was merged with the Taluka value instead of any date at
                // all. Net effect, confirmed live for Roll 1004: "Reporting Address" showed the
                // candidate's home town, and "Reporting Date" showed a place name ("National City")
                // instead of a date. The real appointment Date/Time were fetched from the API but never
                // used anywhere. Fixed by restoring "ठिकाण"→Venue (matching the original intended
                // design above) and rebinding "ता:"→the real AppointmentDate; a new "Reporting Time"
                // line/token was added to Post.AppointmentLetterNote (both Posts) for AppointmentTime,
                // completing the one genuinely missing field rather than leaving it silently dropped.
                let updateNameInAppointmentLetter = AppointmentLetter.replace("उमेदवारांचे नाव", name);
                let updateAdressInAppointmentLetter = updateNameInAppointmentLetter.replace("ठिकाण", Venue);
                let updateOther1InAppointmentLetter = updateAdressInAppointmentLetter.replace("शा:", Other1);
                let updateDateInAppointmentLetter = updateOther1InAppointmentLetter.replace("ता:", AppointmentDate);
                let updateTimeInAppointmentLetter = updateDateInAppointmentLetter.replace("{ReportingTime}", AppointmentTime);
                let updateRollInAppointmentLetter = updateTimeInAppointmentLetter.replace("बैठकक्र", Roll_Number);
                // Quick fix: the letter never actually named the post the candidate was being
                // appointed to — "selected for appointment to the post advertised..." with no post
                // named anywhere. Applied_Post was already being fetched here but never used.
                let mainAppointmentLetter = updateRollInAppointmentLetter.replace("{PostName}", Applied_Post);


                this.setState({
                    ...this.state,
                    AppointmentLetterNote: mainAppointmentLetter,
                    // Note: AppointmentLetter,
                    loading: false,
                    // Branding/UI Artifact Forensic Audit phase: captured only so onPrint can build a
                    // meaningful, candidate-specific download filename (see buildAppointmentLetterFileName)
                    // instead of the previous generic "Student_Appointment_Letter.pdf" every candidate got.
                    fileNameModel: { ApplicationId: Application_Id, CandidateName: name, RollNumber: Roll_Number },
                    // Quick fix: the letter's date must be when the Final Result was actually
                    // published (Selected), not the day the candidate happens to view/download it.
                    // Sourced server-side from AuditLog (StudentAppointmentServices), never
                    // client-side `new Date()`.
                    publishedDate: studentData.PublishedDate,
                    rollNumberForRef: Roll_Number,
                });

            } catch (e) {
                // TODO
                this.setState({ loading: false });
                console.log('Error: ', e);
            }
        } catch (e) { }
    }

    onPrint = () => {
        this.setState({ isLoading: true });
        const originalDiv = document.querySelector("#divReceiptPrint");

        // Clone the div to avoid modifying the original
        const clonedDiv = originalDiv.cloneNode(true);
        clonedDiv.style.position = "absolute";
        clonedDiv.style.left = "-9999px";
        clonedDiv.style.width = "1041.89px";
        document.body.appendChild(clonedDiv);


        html2canvas(clonedDiv, {
            scale: 3, allowTaint: true, useCORS: true
        }).then(canvas => {
            const imgData = canvas.toDataURL('image/jpeg', 0.8);

            const doc = new jsPDF({
                orientation: 'p',
                unit: 'pt',
                format: 'a4',
                compressPdf: true
            });

            const pageWidth = 595.28;
            const pageHeight = 841.89;

            const margin = 1; // Margin for all sides
            const contentWidth = pageWidth - margin * 2;
            const contentHeight = pageHeight - margin * 2;

            const widthRatio = contentWidth / canvas.width;
            const heightRatio = contentHeight / canvas.height;
            const ratio = Math.min(widthRatio, heightRatio);

            const canvasWidth = canvas.width * ratio;
            const canvasHeight = canvas.height * ratio;

            // Center the image within the margins
            const xOffset = margin + (contentWidth - canvasWidth) / 2;
            const yOffset = margin;

            doc.addImage(imgData, 'JPEG', xOffset, yOffset, canvasWidth, canvasHeight);
            // Branding/UI Artifact Forensic Audit phase: every candidate previously downloaded the
            // exact same generic "Student_Appointment_Letter.pdf" — meaningless once more than one
            // candidate's letter exists on the same device/downloads folder. Now matches the same
            // meaningful-filename convention already used by the Interview Call Letter/Hall Ticket.
            doc.save(_utils.buildAppointmentLetterFileName(this.state.fileNameModel));
            document.body.removeChild(clonedDiv);
            this.setState({ isLoading: false });
        });

    }

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    onTabOrderChange = () => {
        this.props.onTabOrderChange(7);
    }

    render() {
        if (this.state.isLoading)
            return <Spin size="large" />

        return (
            <>
                <div className="analysisWrap pt-3 pb-3 p-sm-4 p-md-5" style={{ alignItems: 'center' }}>
                    {/* Quick fix: page was left bilingual (English + Marathi) from this screen's
                        original authoring, inconsistent with the rest of the now-English-only
                        modernized candidate journey. Reported and fixed — English only throughout
                        this component now (heading, date/ref line, signatory line, buttons). */}
                    <h5 className="heading mb-4">Candidate Appointment Letter</h5>
                    {/* Quick fix (formatting): margin bumped 30px→45px to match the Interview Call
                        Letter's own standardized margin (InterviewCallLetter.jsx) and read as a
                        genuine letter margin rather than text sitting close to the page edge. */}
                    <div id="outerBorder" style={{ border: 'solid', borderColor: 'gray' }}>
                        <div id="divReceiptPrint" style={{ border: 'solid', borderColor: 'transparent', padding: "45px" }}>
                            {/* Production Candidate Journey Correction phase — real defect fix: this
                                whole header block used to hard-code a real institution's actual
                                letterhead (name, head-office address, fax/EPBX numbers, and a real
                                admin@/www. domain for "Ahmednagar District Central Co-op Bank") —
                                completely unrelated to this portal's own "National Bank" identity, and
                                jarringly inconsistent with the correctly-branded Post.AppointmentLetterNote
                                content rendered just below it. This component was dead code until the
                                Candidate Journey Artifact Stabilization phase made the Appointment Letter
                                action reachable for the first time, so this had never been visually
                                exercised/caught before. Fixed by reusing the exact same branding-driven
                                pattern InterviewCallLetter.jsx already uses correctly (Portal_Logo →
                                branding LogoUrl → PROJECT_LOGO priority chain via _branding.resolveLogoUrl,
                                org name via _branding.getOrganizationName) instead of any hardcoded
                                institution identity — the admin-authored AppointmentLetterNote below
                                already carries its own "NATIONAL BANK" heading, so this header now only
                                shows the logo, matching the rest of the candidate journey's letters. */}
                            <div style={{ textAlign: "center", padding: '10px', margin: '2px', paddingBottom: "3px" }}>
                                <img
                                    src={_branding.resolveLogoUrl(localStorage['Portal_Logo'], PROJECT_LOGO)}
                                    alt={_branding.getOrganizationName('Organization Logo')}
                                    style={{ width: "150px", cursor: "pointer" }}
                                />
                            </div>

                            {/* Quick fix: "Ref: Personnel/Appointment" was a static, meaningless
                                leftover phrase (no actual reference number) — replaced with a real,
                                candidate-specific reference built from the roll number, matching
                                standard official-letter convention. The date is now the real Final
                                Result publish date (see processAppointmentData/PublishedDate), never
                                the day the candidate happens to view/download the letter — a candidate
                                re-downloading this letter next year must still see the original
                                release date, not "today". */}
                            <div style={{ display: "flex", marginTop: "20px", fontSize: "18px", color: "rgb(0 0 0)", justifyContent: "space-between" }}>
                                <div style={{ textAlign: "left" }}>Ref: NB/APT/{this.state.rollNumberForRef}/2026</div>
                                <div style={{ textAlign: "right" }}>
                                    Date: {this.state.publishedDate}
                                </div>

                            </div>
                            {/* <div style={{ textAlign: "center", marginTop: "10px", fontSize: "26px", color: "black", fontWeight: "bold", justifyContent: "space-between" }}>
                                कागदपत्र पडताळणी/मुलाखत पत्र
                            </div> */}
                            {/* Quick fix: removed a second, hardcoded "Chief Executive Officer"
                                signature line that sat right below the admin-authored template's own
                                "Human Resources / National Bank" signature — a redundant leftover from
                                this component's original Ahmednagar-DCC-derived authoring, never
                                reconciled with the real signature the template already provides. */}
                            <div>
                                <div className='interviewCall' dangerouslySetInnerHTML={{ __html: this.state.AppointmentLetterNote }}></div>
                            </div>


                        </div>
                    </div>
                    {/* Branding/UI Artifact Forensic Audit phase: (1) this button's own label
                        previously said "Print / Download Receipt" (पावती = "receipt") — copy-pasted
                        from an actual Receipt-download screen and never updated for this Appointment
                        Letter screen; corrected to describe what this button actually downloads. (2)
                        Both buttons rebuilt on antd `Button` + `button-global` classes — the same
                        design language ResultCard_new.jsx already uses — instead of the older
                        `ButtonComponent`/`btn-secondary`/`btn-tertiary` styling reported as looking
                        inconsistent with the rest of the modernized candidate journey.
                        Quick fix: the Marathi second line (मागे जा / नियुक्ती पत्र प्रिंट करा...) was
                        reported as inconsistent with the now English-only journey — removed; English
                        label only, same `displayInGrid` wrapper dropped since it only ever stacked two
                        lines. */}

                    <div className="row mt-4 footer-buttons">
                        <div className="col-12">
                            <div className="form-action d-flex justify-content-center flex-wrap">
                                <Button
                                    id="btnCancel"
                                    className="button-global button-border autoHeight ml-4 mb-2 autoWidth"
                                    onClick={this.onCancel}
                                >Back</Button>

                                <Button
                                    id="btnPrint"
                                    className="button-global button-primary autoHeight ml-4 mb-2 autoWidth"
                                    onClick={this.onPrint}
                                >Print / Download Appointment Letter</Button>
                            </div>
                        </div>
                    </div>
                    {this.state.loading && <Spin size="large" />}
                </div>
            </>
        )
    };
}

export default StudentAppointmentLetter;